<template>
  <Header v-bind:pinned-event="pinnedEvent" v-bind:language="language" />
  <div class="events-wrapper">
    <Events v-bind:events="checkedEvents" v-bind:scrollToId="scrollToId" />
    <JobBanner v-bind:banner="bottomBanner" />
  </div>
  <Footer />
</template>

<script>
  import Header from '@/components/Header';
  import Events from '@/components/Events';
  import JobBanner from '@/components/JobBanner';
  import Footer from '@/components/Footer';

  import '@/styles/style.scss';

  export default {
    name: 'App',
    components: {
      Footer,
      JobBanner,
      Header,
      Events,
    },
    data: () => {
      return {
        bottomBanners: window.aboutUs.bottomBanner,
        events: window.aboutUs.events,
        scrollToId: window.aboutUs.scrollToId,
        language: window.language,
      }
    },
    computed: {
      pinnedEvent: function() {
        const events = [].concat.apply([], Object.values(this.events[this.$root.$i18n.locale]));
        return events.filter((event) => event.pinned)?.[0] || null;
      },
      checkedEvents: function() {
        const events = {...this.events[this.$root.$i18n.locale]};
        Object.keys(this.events[this.$root.$i18n.locale]).forEach(function(year) {
          if (!events[year].length) {
            delete events[year];
          }
        });
        return events;
      },
      bottomBanner: function() {
        return this.bottomBanners[this.$root.$i18n.locale];
      }
    },
  };
</script>

<style lang="scss">
  @import '@/styles/functions.scss';

  .events-wrapper {
    padding: 0 16px;

    @include media-breakpoint-up(md) {
      padding: 0 26px;
    }
  }
</style>
